<template>
    <section id="service-intro" class="service-intro">
        <div class="container">
            <div class="pc-image">
                <!-- use slot to avoid vite new URL cannot deal with resolve.alias. Same below. -->
                <!-- https://github.com/vitejs/vite/issues/10597 use vite plugin would be better -->
                <slot name='slot-pc-image' />
            </div>
            <div class="notice">
                <h5 class="subtitle">{{ subtitle }}</h5>
                <h3 class="title pc-title">{{ title }}</h3>
                <h3 class="m-title">{{ title }}</h3>
                <p class="des">{{ desc }}</p>
                <reo-common-button
                    :label="$t('basicPlan.learnMore')"
                    ga-label="Homepage go to subscribe cloud"
                    @click="handleLearnMore"
                    class='learn-more-btn'
                    :custom-width="!isMobile ? 200: undefined"
                />
            </div>
            <div class='m-image'>
                <slot name='slot-mobile-image' />
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoCommonButton from '@/components/ReoCommonButton.vue';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({

    components: {
        ReoCommonButton
    },

    props: {
        title: String,
        subtitle: String,
        desc: String,
        navigateTo: Function,
        image: String,
        type: String
    },

    data () {

        return {

        };

    },
    computed: {
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
    },
    methods: {
        handleLearnMore() {

            reolinkGa.sendSimpleEvent( `${this.type}-learn more` );
            this.navigateTo?.();

        }
    }

});

</script>

<style scoped rel="stylesheet/css" lang="less">

    .service-intro {
        padding: 50px 0;
        background-color: @bg_01;
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: @white;
            border-radius: @border-radius-level-1;

            .notice {
                text-align: left;
                max-width: 500px;
                padding: 0 50px;
                display: flex;
                flex-direction: column;
                gap: 12px;
                line-height: 1.5;

                .des {
                    font-size: 16px;
                }
                .title {
                    font-size: 36px;
                    font-weight: 600;
                }
                .subtitle {
                    font-size: 24px;
                    font-weight: 500;
                }
                .pc-title {
                    display: block;
                }
                .m-title {
                    display: none;
                }
                .learn-more-btn{
                    margin-top: 20px;
                }
            }
            .pc-image {
                display: block;
                height: 600px;
                width: 600px;
                img{
                    height: 100%;
                }
            }
            .m-image {
                display: none;
            }
        }

        @media @mobile{
            padding: 0 20px;
            .container {
                display: block;
                border-radius: @border-radius-level-1;

                .notice {
                    max-width: 100%;
                    padding: 20px;
                    padding-bottom: 0;
                    gap: 8px;
                    line-height: 1.5;
                    .subtitle{
                        font-size: 16px;
                    }
                    .pc-title {
                        display: none;
                    }
                    .m-title {
                        display: block;
                        font-weight: 600;
                        font-size: 24px;
                    }
                    .des {
                        font-size: 14px;
                    }
                    .learn-more-btn{
                        margin-top: 16px;
                    }
                }
                .m-image {
                    display: flex;
                    width: 100%;
                    margin-top: 24px;
                    img{
                        border-radius: 0 0 12px 12px;
                        height: 100%;
                        width: 100%;
                    }
                }
                .pc-image {
                    display: none;
                    background: none;
                }
            }

        }
    }

</style>
